export const OEProductId = {
    humanFoot:                                      '1000100000',
    humanEye:                                       '1000200000',
    humanSkull:                                     '1000300000',
    humanCranialNerves:                             '1000310000',
    humanSkin:                                      '1000500000',
    humanKnee:                                      '1000600000',
    humanKneeImplantcast:                           '1000610000',
    implantcastACSMB4in1:                           '1000630000',
    implantcastACSSCFB:                             '1000640000',
    implantcastAGILONMI:                            '1000650000',
    implantcastACSSCMB:                             '1000660000',
    implantcastMutarsDistFemurMK:                   '1000620000',
    implantcastMUTARSGenuXMK:                       '1000670000',
    implantcastMUTARSKRIMK:                         '1202100000',
    implantcastEcoFitHipStem133123:                 '1000680000',
    implantcastEcoFitHipStem:                       '1200690000',
    implantcastEcoFitShortStem:                     '1200700000',
    implantcastEcoFitCup:                           '1200730000',
    implantcastActiniaStem:                         '1200710000',
    implantcastShoulderApproachAnterior:            '1200720000',
    implantcastTestTarget:                          '1200000001',
    humanEar:                                       '1000700000',
    humanLeg:                                       '1000800000',
    humanAnkleFoot:                                 '1000810000',
    humanHip2:                                      '1000820000',
    humanLegPathways:                               '1000830000',
    humanLowerLeg:                                  '1000840000',
    humanThighKnee:                                 '1000850000',
    humanArm:                                       '1000900000',
    humanArmPathways:                               '1000910000',
    humanBodyMuscles:                               '1000010000',
    humanForearm:                                   '1000920000',
    humanUpperArmElbow:                             '1000930000',
    humanHip:                                       '1001000000',
    humanShoulder:                                  '1001100000',
    humanElbow:                                     '1001200000',
    humanHand:                                      '1001300000',
    humanTrunk:                                     '1001400000',
    humanAbdominalWall:                             '1001410000',
    humanChestWall:                                 '1001420000',
    humanNeckBack:                                  '1001430000',
    humanPelvis:                                    '1001440000',
    humanShoulderGirdle:                            '1001450000',
    humanSpine:                                     '1001460000',
    humanSpineFracture:                             '1001470000',
    humanHead:                                      '1001500000',
    humanHeadWIP:                                   '1001530000',
    humanLarynx:                                    '1001510000',
    humanEye2:                                      '1001520000',
    humanEyeRetina:                                 '1001540000',
    humanEyeOCT:                                    '1001550000',
    humanLiverMicro:                                '1002010000',
    humanHeart:                                     '1002100000',
    equineHoof:                                     '1010100000',
    equineHead:                                     '1010800000',
    mouseBrain:                                     '1040900000',
    combustionEngine:                               '1212000000',
    anatomy:                                        '1000000000',
    ortho:                                          '1100000000',
    implantcast:                                    '1200000000',
    sensorySystems:                                 '3000000002',
    animalSnail:                                    '1055000000',
    thieme:                                         '1300000000',
    demo:                                           '1000000000',
    toxnetz:                                        '1989800000',
    zeissUV:                                        '2000000001',
    zeissOpti:                                      '2000000002',
    optics:                                         '4000000001',
    animalCell:                                     '1500000000',
    plantCell:                                      '1600000000',
    humanCellEpithelium:                            '1700000000',
    xRay:                                           '2000000003',
    xRayExplorer:                                   '2000000003',
    xRayIcarus:                                     '4000000002',
    surgery:                                        '3000000001',
    bbraun:                                         '2000000005',
    school:                                         '2000000006',
    science:                                        '2000000007',
    sport:                                          '2000000008',
    knowOn:                                         '4000000001',
// @ADD_TARGET_ALL_PRODUCTID (see object_explorer/ObjExplorer/Classes/Misc/OEProductId.h)
    schoolAtomicModel              : '1989900010',
    xRayUpperExtremityMobile       : '4000000008',
    xRayTrunkMobile                : '4000000007',
    xRayLowerExtremityMobile       : '4000000006',
    schoolGeometrie                : '1989900009',
    thiemeShoulderGirdleAnimation  : '1300000115',
    xRayTrunk                      : '4000000005',
    xRayUpperExtremity             : '4000000004',
    xRayLowerExtremity             : '4000000003',
    thiemeEyeAnimation             : '1300000114',
    humanEyeAmetropia              : '1001620000',
    surgeryOHSTPrimaCurve          : '1900000006',
    sportShoulderGirdle            : '2000000801',
    schoolCellDivision             : '1989900008',
    schoolSkull                    : '1989900007',
    schoolRefrigerator             : '1989900006',
    schoolVolcano                  : '1989900004',
    schoolToxin                    : '1989900005',
    humanBonesSchool               : '1002800001',
    humanBones                     : '1002800000',
    schoolSolarSystem              : '1989900003',
    humanRespiratoryEpithelium     : '1002700000',
    humanMuscleSpindle             : '1002600000',
    humanBronchialTree             : '1002500000',
    humanRespiratorySystem:                         '1002400000',
    humanGenitalMale:                               '1002050000',
    thiemeLarynxAnimation:                          '1300000113',
    virusSarscov2:                                  '3000000002',
    schoolSouthAmerica:                             '1989900002',
    schoolFormelsammlung:                           '1989900001',
    thiemeEarMacro:                                 '1300000025',
    thiemeEarInner:                                 '1300000024',
    techEngineOtto:                                 '1213000000',
    surgeryLinkEmbrace:                             '1900000005',
    surgeryBbraunOneKnee:                           '1900000004',
    thiemeCNS:                                      '1300000023',
    surgeryIdo:                                     '1900000003',
    humanCNSWIP:                                    '1002200001',
    surgeryAppendix:                                '1900000002',
    humanSkin2:                                     '1000520000',
    humanSkinEpidermis:                             '1000510000',
    humanEyeMuellerCell:                            '1001610000',
    humanTrunkVessel:                               '1001401000',
    humanSpineFracture2:                            '1001480000',
    humanPatient:                                   '1002300000',
    humanCNS:                                       '1002200000',
    humanEarInner:                                  '1000710000',
    humanEyeMembrane:                               '1001600000',
    humanEyeOcclusion:                              '1001590000',
    surgeryEyeCataract:                             '1900000001',
    humanHeadreduced1:                              '1001532000',
    implantcastDemoMutarsKRIMK:                     '1202100001',
    humanEyeLid:                                    '1001580000',
    implantcastHAPTic:                              '1211200000',
    humanLiverEnzyme2:                              '1002040000',
    humanEyeDMOE:                                   '1001570000',
    humanLiverEnzyme:                               '1002030000',
    humanBrainPotential:                            '1000360000',
    implantcastICARA:                               '1211100000',
    implantcastCarpoFit:                            '1211000000',
    implantcastIntramedullaryPlug:                  '1210000000',
    implantcastHipDorsalApproach:                   '1209000000',
    implantcastKneeMedialParapatellarApproach:      '1208000000',
    implantcastKneeLateralParapatellarApproach:     '1207000000',
    thiemeEye2:                                     '1300000022',
    thiemeEyeRetina:                                '1300000021',
    thiemeTrunk:                                    '1300000020',
    thiemeSpine:                                    '1300000019',
    thiemeNeckBack:                                 '1300000018',
    thiemeChestWall:                                '1300000017',
    thiemeAbdominalWall:                            '1300000016',
    thiemeCranialNerves:                            '1300000015',
    thiemeHead:                                     '1300000014',
    thiemeLarynx:                                   '1300000013',
    thiemePelvis:                                   '1300000012',
    thiemeThighKnee:                                '1300000011',
    thiemeLowerLeg:                                 '1300000010',
    thiemeLeg:                                      '1300000009',
    thiemeHip2:                                     '1300000008',
    thiemeAnkleFoot:                                '1300000007',
    humanBrainACh:                                  '1000350000',
    humanLiverSinusoid:                             '1002020000',
    implantcastMutarsRScup:                         '1206000000',
    implantcastEporeMetaphysealComponentsGenuX:     '1205000000',
    thiemeArm:                                      '1300000006',
    thiemeUpperArmElbow:                            '1300000005',
    thiemeShoulderGirdle:                           '1300000004',
    thiemeForearm:                                  '1300000003',
    thiemeHand:                                     '1300000002',
    implantcastMutarsProxFemurDiaphyse:             '1204000000',
    implantcasticStraightStem:                      '1203000000',
    implantcastMutarsProxFemurRevision:             '1202000000',
    implantcastDiaLocRS:                            '1201900000',
    toxnetzFormelsammlung:                          '1989900000',
    materialTestTarget:                             '1100000001',
    implantcastMutarsTotalHumerus:                  '1201800000',
    implantcastMutarsDistHumerus30mm:               '1201700000',
    implantcastACSUniFB:                            '1201600000',
    effigosExplorerHelp:                            '1100000002',
    implantcastEporeConeKRIundRSArthrodese:         '1201500000',
    implantcastEporeConesCortical:                  '1201400000',
    implantcastMutarsDiaphysealImplant:             '1201300000',
    implantcastMutarsProxFemurRS:                   '1201200000',
    implantcastACSMBAllinOne:                       '1201100000',
    implantcastMutarsDistHumerus50mm:               '1201090000',
    implantcastMutarsTotalKneeKRIMK:                '1201080000',
    implantcastMutarsTotalKneeMK:                   '1201070000',
    implantcastMutarsIntramedtotalFemurMK:          '1201060000',
    implantcastMutarsHumerusDiaphysealImplant:      '1201050000',
    implantcastACSUniSG:                            '1201040000',
    implantcastEporeConesMetaphyseal:               '1201030000',
    implantcastMutarsTotalElbow:                    '1201020000',
    implantcastACSFBAllinOne:                       '1201010000',
    humanEyeAMD:                                    '1001560000',
    implantcastMutarsIntramedtotalFemurGenuX:       '1201000000',
    implantcastMutarsArthrodesisimplant:            '1200100000',
    humanBrainMembrane:                             '1000340000',
    implantcastMutarsProxUlnaLongFit:               '1200990000',
    humanBrainNeuron:                               '1000330000',
    implantcastMutarsTorqueWrench:                  '1200980000',
    implantcastMutarsRSArthrodesisImplant:          '1200970000',
    thiemeSkull:                                    '1300000001',
    implantcastDeltopectoralApproach:               '1200960000',
    implantcastMutarsTotalesFemurMK:                '1200950000',
    implantcastMutarsDistFemurRS:                   '1200940000',
    implantcastMutarsHumerusInvers:                 '1200930000',
    implantcastMUTARSModularStem:                   '1200920000',
    implantcastEcoFitHipStem123:                    '1200910000',
    implantcastPEcupMuellerII:                      '1200900000',
    implantcastEcoFitSC:                            '1200890000',
    implantcastEcoFit2MSP:                          '1200880000',
    implantcastEcoFit2M:                            '1200870000',
    implantcastMutarsProxFemur:                     '1200860000',
    implantcastMUTARSProxTibiaMK:                   '1200850000',
    implantcastMutarsProxHumerus:                   '1200840000',
    implantcastMutarsLumic:                         '1200830000',
    implantcastAgilonPEGlenoid:                     '1200820000',
    implantcastAGILONGlenoidzementfrei:             '1200810000',
    humanHeadLeFx:                                  '1001531000',
    implantcastAidaShortStem:                       '1200800000',
    humanBrainSynapse:                              '1000320000',
    implantcastAGILONTraumalongfit:                 '1200790000',
    implantcastMutarsRS:                            '1200780000',
    implantcastDirectAnteriorApproach:              '1200770000',
    implantcastEcoFitCupEPORE:                      '1200760000',
    implantcastMUTARSPRS:                           '1200750000',
    implantcastAGILONOmarthrosisLongFit:            '1200740000',
};

export default OEProductId;